import React from 'react';

export function APIReference() {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">API Reference</h1>
      <p className="text-gray-600">API documentation coming soon...</p>
    </div>
  );
}